const WORK_STATUS = {
  pending: { label: "PENDING", dot: "🟡", cls: "bg-amber-50 text-amber-700 border border-amber-200" },
  active: { label: "ACTIVE", dot: "🔵", cls: "bg-blue-50 text-blue-700 border border-blue-200" },
  hold: { label: "HOLD", dot: "🟠", cls: "bg-orange-50 text-orange-700 border border-orange-200" },
  completed: { label: "COMPLETED", dot: "🟢", cls: "bg-green-50 text-green-700 border border-green-200" },
};

export default function WorkStatusBadge({ status }) {
  const s = (status || "pending").toLowerCase();
  const cfg = WORK_STATUS[s] || WORK_STATUS.pending;
  return (
    <span className={`badge ${cfg.cls}`} data-testid={`workstatus-${s}`}>
      <span aria-hidden>{cfg.dot}</span> {cfg.label}
    </span>
  );
}

export { WORK_STATUS };
